import { Component, OnInit, Input, TemplateRef, ViewContainerRef, Output, EventEmitter, ContentChild, forwardRef, SimpleChanges, ChangeDetectorRef, ChangeDetectionStrategy, Renderer2, ViewChild } from '@angular/core';
// import { OverlayService } from '../common';
import { NpDropdownItemDirective } from './dropdown-item.directive';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { OverlayService } from '../common/overlay.service';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';

/**
 * ä¸æéæ©ç»ä»¶ - æ¯æåéåå¤éåè½
 * 
 * <example-url>https://stackblitz.com/edit/np-dropdown-sample?embed=1&file=src/app/app.component.html</example-url>
 * 
 */
@Component({
  selector: `np-dropdown`,
  templateUrl: 'dropdown.html',
  styleUrls: ['dropdown.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.disabled]': 'disabled === "true" || disabled === true'
  },
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => NpDropdown),
      multi: true,
    }]
})
export class NpDropdown implements OnInit, ControlValueAccessor {
  private emitChange = (_: any) => { };

  /**æ¯å¦ç¦ç¨ç¶æ */
  @Input() disabled: any = false;

  /**ä¸æç»ä»¶çåºç¡è®¾ç½®ï¼å¦æ¯å¦åéç­ */
  @Input() settings: NpDropdownSettings;

  /**å¨é¨ä¸æéé¡¹ */
  @Input() items: Array<NpDropdownItem> = [];

  /**å·²éé¡¹ - åéä¸ºä¸ä¸ªå¯¹è±¡ï¼ å¤éåä¸ºä¸ç»æ°ç» */
  @Input() selectedItem: NpDropdownItem | Array<NpDropdownItem>;

  /**éæ©æ¶è§¦å */
  @Output() onSelected = new EventEmitter<NpDropdownItem | Array<NpDropdownItem>>();
  /**åæ¶éæ©æ¶è§¦å */
  @Output() onDeselected = new EventEmitter<NpDropdownItem | Array<NpDropdownItem>>();
  /**å¨éæ¶è§¦å */
  @Output() onSelectedAll = new EventEmitter<NpDropdownItem | Array<NpDropdownItem>>();
  /**åæ¶å¨éæ¶è§¦å */
  @Output() onDeselectedAll = new EventEmitter<NpDropdownItem | Array<NpDropdownItem>>();

  @ContentChild(NpDropdownItemDirective) selectItemRef: NpDropdownItemDirective;

  @ViewChild('virtualScrollViewport') viewPort: CdkVirtualScrollViewport;

  private originItems: Array<NpDropdownItem> = [];
  /**æ¥è¯¢Token */
  searchToken: string;

  //#region Getter
  /**åéä¸ææ¡ */
  get selectedLabel() {
    this.checkItemExists();

    if (this.settings.single) {
      return this.selectedItem ? (this.selectedItem as NpDropdownItem).label : this.settings.placeHolder;
    }

    return this.settings.placeHolder;
  }

  /**å¤éä¸ææ¡ */
  selectedItems: Array<NpDropdownItem> = [];
  selectedBadgeItems: Array<NpDropdownItem> = [];
  noneBadgeCount: number = 0;

  private buildMultipleSelect() {
    if (this.settings.single) {
      return;
    }

    //#region selectedItems
    this.checkItemExists();
    let selectedItems = this.selectedItem as Array<NpDropdownItem>;
    if (selectedItems && selectedItems.length > 0) {
      this.selectedItems = [...selectedItems];
    } else {
      this.selectedItems = [{ id: -1, label: this.settings.placeHolder }];
    }
    //#endregion

    //#region selectedBadgeItems
    let items = [...this.selectedItems];
    items.splice(this.settings.badge);
    this.selectedBadgeItems = items;
    //#endregion

    this.noneBadgeCount = this.selectedItems.length - this.settings.badge;

    this.cdf.detectChanges();
  }

  get isDropdownOpen() {
    return this.overlayService.isAttached();
  }

  get isItemSelected() {
    if (this.settings.single) {
      return this.selectedLabel !== this.settings.placeHolder;
    }

    // Multiple dropdown
    if (this.selectedItems && this.selectedItems.length > 0) {
      return this.selectedItems[0].label !== this.settings.placeHolder;
    }

    return false;
  }

  _isCheckedAll: boolean = false;
  get isCheckedAll() {
    return this.items.length === this.selectedItem.length;
  }

  set isCheckedAll(val: boolean) {
    this._isCheckedAll = val;
  }
  //#endregion

  constructor(private viewContainerRef: ViewContainerRef,
    private overlayService: OverlayService,
    private cdf: ChangeDetectorRef,
    private renderer2: Renderer2) { }

  ngOnInit(): void {
    this.init();
  }

  ngOnChanges(changes: SimpleChanges) {
    let items = changes['items'];
    if (items && items.currentValue && items.currentValue.length >= 0) {
      this.originItems = [...items.currentValue];
    }
  }

  onSelectAll(checked: boolean) {
    this.items.forEach(item => {
      item.checked = checked;
    });

    this.selectedItem = checked ? [...this.items] : [];
    this.buildMultipleSelect();
    this.onSelectedAll.emit(this.selectedItem);
    this.emitChange(this.selectedItem);
  }

  onSelect(item: NpDropdownItem) {
    if (this.settings.single) {
      this.selectedItem = item;
      this.onSelected.emit(item);
      this.emitChange(item);
      this.cdf.detectChanges();

      this.overlayService.close({ item: item });
      return;
    }

    //#region Multiple dropdown
    if (!this.selectedItem || !this.selectedItem.length) {
      this.selectedItem = [];
    }

    if (item.checked) {
      this.selectedItem.push(item);
    } else {
      this.selectedItem = this.selectedItem.filter((f: NpDropdownItem) => f.id !== item.id);
    }

    this.buildMultipleSelect();
    this.onSelected.emit(item);
    this.emitChange(this.selectedItem);
    //#endregion
  }

  onSearch(val: any) {
    if (!val) {
      this.clearSearch();
      return;
    }

    this.items = this.originItems.filter(f => f.label.indexOf(val) > -1);
  }

  isActive(item: NpDropdownItem) {
    if (!this.selectedItem) {
      return false;
    }

    if (this.settings.single) {
      return item.id === (this.selectedItem as NpDropdownItem).id;
    }

    // Multiple dropdown
    return this.selectedItem.find(f => f.id === item.id);
  }

  onOpenDropdown($event: MouseEvent, dropdownTpl: TemplateRef<any>, origin: HTMLElement) {
    $event.stopPropagation();

    if (this.disabled) {
      return;
    }

    if (this.isDropdownOpen) {
      this.overlayService.close(null);
      return;
    }

    this.overlayService.openDropdown(origin, dropdownTpl, this.viewContainerRef, null).subscribe(() => {
      // close
    });

    this.buildItemsCheckedStatus();
    setTimeout(() => {
      this.scrollToSelectedItem();
    }, 100);

    // Tricky... Can't get inner element in np-input control, so we need set
    // style async after open dropdown
    setTimeout(() => {
      if (!this.overlayService.overlayRef || !this.overlayService.overlayRef.overlayElement) {
        return;
      }

      let npInputWrapper = this.overlayService.overlayRef.overlayElement.getElementsByClassName('np-input-wrapper');
      let inputContainer = this.overlayService.overlayRef.overlayElement.getElementsByClassName('input-container');
      let npInput = this.overlayService.overlayRef.overlayElement.getElementsByClassName('np-input');
      if (npInputWrapper && npInputWrapper.length > 0) {
        this.renderer2.setStyle(npInputWrapper[0], 'width', '100%');
      }

      if (inputContainer && inputContainer.length > 0) {
        this.renderer2.setStyle(inputContainer[0], 'width', '100%');
      }

      if (npInput && npInput.length > 0) {
        this.renderer2.setStyle(npInput[0], 'width', this.settings.width + 'px');
        this.renderer2.setStyle(npInput[0], 'padding-left', '30px');
        this.renderer2.setStyle(npInput[0], 'border-top', 'none');
        this.renderer2.setStyle(npInput[0], 'border-left', 'none');
        this.renderer2.setStyle(npInput[0], 'border-right', 'none');
        this.renderer2.setStyle(npInput[0], 'box-shadow', 'none');
      }
    }, 0);
  }

  onRemoveItems($event: MouseEvent) {
    if (this.disabled) {
      return;
    }

    this.selectedItem = this.settings.single ? null : [];
    this.clearSearch();
    this.items.forEach(item => {
      item.checked = false;
    });

    this.buildMultipleSelect();
    this.onDeselectedAll.emit(this.items);
    this.emitChange(this.selectedItem);
    $event.stopPropagation();
  }

  onRemoveItem($event: MouseEvent, item: NpDropdownItem) {
    if (this.disabled) {
      return;
    }

    this.selectedItem = this.selectedItem.filter((f: NpDropdownItem) => f.id !== item.id);
    this.clearSearch();

    item.checked = false;

    this.buildMultipleSelect();
    this.onDeselected.emit(item);
    this.emitChange(this.selectedItem);
    $event.stopPropagation();
  }

  //#region Implementation for ControlValueAccessor
  writeValue(obj: any): void {
    // å¦ææ¯å¤éä¸ææ¡ï¼ä¼ å¥çselectedItemæ¯nullï¼ä¸ºäºé²æ­¢æ¥éç´æ¥returnï¼å¿é¡»ä¼ å¥ç©ºæ°ç»[]
    if (obj === null && !this.settings.single) {
      return;
    }

    this.selectedItem = obj;
    if (this.settings.single) {
      this.cdf.detectChanges();
    } else {
      this.selectedItem.forEach(item => {
        if (item.checked === undefined) {
          item.checked = true;
        }
      });
      this.buildMultipleSelect();
    }
  }

  registerOnChange(fn: any): void {
    this.emitChange = fn;
  }

  registerOnTouched(fn: any): void { }
  //#endregion

  //#region Private methods
  private init() {
    this.originItems = [...this.items];
    let initSettings: NpDropdownSettings = {
      single: true,
      placeHolder: 'è¯·éæ©',
      width: 220,
      badge: 99999,
      isShowSearchBox: true,
      noData: 'æ²¡ææ°æ®ï¼',
      autoScrollTo: true
    };

    this.settings = Object.assign(initSettings, this.settings);
  }

  private checkItemExists() {
    if (this.settings.single) {
      if (this.selectedItem && !this.originItems.find(f => f.id === (this.selectedItem as NpDropdownItem).id)) {
        this.selectedItem = null;
      }
    } else {
      // Multiple dropdown
      if (this.selectedItem && this.selectedItem.length > 0) {
        let selectedItems = [];
        this.selectedItem.forEach((item: NpDropdownItem) => {
          if (this.originItems.find(f => f.id === item.id)) {
            selectedItems.push(item);
          }
        });

        this.selectedItem = [];
        this.selectedItem = selectedItems;
      }
    }
  }

  /**
   * æ¸é¤æ¥è¯¢å¹¶å±ç¤ºææç¬¦åæ¡ä»¶çitems
   */
  private clearSearch() {
    this.searchToken = '';
    this.items = [...this.originItems];

    this.buildItemsCheckedStatus();
  }

  private buildItemsCheckedStatus() {
    if (this.settings.single) {
      return;
    }

    this.items.forEach(item => {
      let selectedItem = this.selectedItem.find(f => f.id === item.id);
      item.checked = selectedItem ? true : false;
    });
  }

  private scrollToSelectedItem() {
    if (!this.settings.autoScrollTo) {
      return;
    }

    let item = this.settings.single ? (this.selectedItem as NpDropdownItem) : (this.selectedItem && this.selectedItem[0]);
    if (item) {
      const selectedIndex = this.originItems.findIndex(f => f.id === item.id);
      this.viewPort.scrollToIndex(selectedIndex, 'smooth');
    }
  }
  //#endregion
}

export interface NpDropdownSettings {
  /**Left side label name */
  lblName?: string;

  /**Set if it is single dropdown, default is true - single dropdown */
  single?: boolean;

  /**Check if it is required. if not, show remove icon, otherwise hide the remove icon */
  isRequired?: boolean;

  /**Placeholder for dropdown */
  placeHolder?: string;

  /**Set the width of dropdown, default is 220, unit px */
  width?: number;

  /**Display badge count, default is 99999 */
  badge?: number;

  /**æ¯å¦å±ç¤ºå¨éæé® */
  isShowCheckedAll?: boolean;

  /**æ¯å¦é»è®¤å¨é */
  isCheckedAll?: boolean;

  /**æ²¡ææ°æ®æ¶å±ç¤ºçææ¡ï¼é»è®¤ä¸ºâæ²¡ææ°æ®ï¼â */
  noData?: string;

  /**æ¯å¦æ¾ç¤ºæç´¢æ¡ï¼é»è®¤å±ç¤º */
  isShowSearchBox?: boolean;

  /**å½ä¸ææ¡æå·²éé¡¹ï¼åéæ¶ï¼æå¼ä¸ææ¡ä¼èªå¨æ»å¨å°å·²éé¡¹ï¼å½ä¸ºå¤éæ¶ï¼æå¼ä¸ææ¡ä¼èªå¨æ»å¨å°å·²éé¡¹çç¬¬ä¸é¡¹ï¼é»è®¤æå¼ä¸ºtrue */
  autoScrollTo?: boolean;
}

export interface NpDropdownItem {
  id: string | number;
  label: string;
  [key: string]: any;
}


